import * as address from '../config/address'
import * as postcodes from '../config/postcodes'
import {
    FETCH_MUSEUMS_TRIGGER,
    FETCH_STORAGE_LOCATIONS_TRIGGER
} from '../constants/quote/step02'

/**
 *  Try to find address list from Postcode
 *
 *  @param  {string} postcode [postcode already preapproved on form]
 *  @method GET
 */
export function findAddress(postcode: string) {

    /**
     * To prevent any costs until the APP is live
     * The next line have been created to look always
     * for the same postcode provided from the provider
     * WR5 3DA
     *
     * these lines should be deleted before the APP goes live.
     */
    // postcode = 'WR5 3DA'

    return {
        type: 'FIND_ADDRESS',
        payload: fetch(`${address.default.urlFind}?Key=${address.default.key}&searchTerm=${postcode}`)
            .then(response => response.json()),
    }
}

/**
 *  Obtain lat & long from postcode
 *
 *  @param  {string} postcode [postcode already preapproved on form]
 *  @method GET
 */
export function findLatLong(postcode: string) {

    return {
        type: 'FIND_LAT_LONG',
        payload: fetch(`${postcodes.default.baseUrl}/${postcode}`)
            .then(response => response.json()),
    }
}

/**
 *  Get address details
 *
 *  @param  {string} id [ID from findAddress request]
 *  @method GET
 */
export function getAddress(id: string) {
    return {
        type: 'GET_ADDRESS',
        payload: fetch(`${address.default.urlGet}?Key=${address.default.key}&id=${id}`)
            .then(response => response.json()),
    }
}

export const fetchMuseums = () => ({
    type: FETCH_MUSEUMS_TRIGGER,
})

export const fetchStorageLocations = () => ({
    type: FETCH_STORAGE_LOCATIONS_TRIGGER,
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/address.ts